import { render, staticRenderFns } from "./SideBarStatus.vue?vue&type=template&id=024a3b74&"
import script from "./SideBarStatus.vue?vue&type=script&lang=js&"
export * from "./SideBarStatus.vue?vue&type=script&lang=js&"
import style0 from "./SideBarStatus.vue?vue&type=style&index=0&id=024a3b74&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports